import { setUnit } from "@/store/features/bulkResize/actions";
import { Unit } from "@/store/types/unit";
import { ChangeEvent } from "react";
import { setHeight, setWidth, setIsLocked } from "store/features/bulkResize/actions";
import { bulkResizeSelector } from "store/features/bulkResize/selectors/bulkResizeSelector";
import { BulkResizeState } from "store/features/bulkResize/types";
import { useAppDispatch, useAppSelector } from "store/store";

export const useSize = () => {
    const {
        images,
        resizeSettings: {
            byDimension: { height, width },
            isLocked,
            unit,
            dpi,
            dimensionType,
        },
    } = useAppSelector(bulkResizeSelector, equalityFn);

    const dispatch = useAppDispatch();

    const handleHeightChange = (e: ChangeEvent<HTMLInputElement>) => dispatch(setHeight(Number(e.target.value)));

    const handleWidthChange = (e: ChangeEvent<HTMLInputElement>) => dispatch(setWidth(Number(e.target.value)));

    const toggleLock = () => dispatch(setIsLocked(!isLocked));

    const handleUnitChange = (unit: Unit) => dispatch(setUnit(unit));
    

    return {
        height,
        width,
        handleHeightChange,
        handleWidthChange,
        isLocked,
        toggleLock,
        unit,
        images,
        dpi,
        dimensionType,
        handleUnitChange
    };
};

const equalityFn = (left: BulkResizeState, right: BulkResizeState) => {
    if (
        left.resizeSettings.byDimension.width !== right.resizeSettings.byDimension.width ||
        left.resizeSettings.byDimension.height !== right.resizeSettings.byDimension.height ||
        left.resizeSettings.isLocked !== right.resizeSettings.isLocked ||
        left.resizeSettings.unit !== right.resizeSettings.unit ||
        left.resizeSettings.dpi !== right.resizeSettings.dpi ||
        left.resizeSettings.dimensionType !== right.resizeSettings.dimensionType ||
        JSON.stringify(left.images) !== JSON.stringify(right.images)
    )
        return false;

    return true;
};
